export interface Testimonial {
  content: string;
  author: string;
  title: string;
}

export const testimonialGroups: Testimonial[][] = [
  [
    {
      content: "I scanned a modest-looking still life at a local gallery, and the app pulled up a fascinating backstory about the artist's time in political exile. It even linked me to a rare archival interview from a university library collection. I never would've learned that from a wall label. This tool doesn't just add context—it creates emotional connections.",
      author: "Irene Tsai",
      title: "Graduate Student, Courtauld Institute of Art"
    },
    {
      content: "I used the app while visiting the Broad Museum in Los Angeles. The AI audio guide felt like listening to a well-produced podcast—engaging, clear, and genuinely insightful. My mom, who doesn't speak English fluently, was able to use it in Spanish and follow along easily. This is the first time we've shared a cultural experience this fully, thanks to multi-language support.",
      author: "Daniel Alvarez",
      title: "Software Engineer, Meta Reality Labs"
    },
    {
      content: "I always take notes when I visit museums, but they usually end up disorganized. This app's journal feature let me save my favorite works, write down reactions, and even upload a few photos I took. After the visit, the personalized summary helped me reflect on my aesthetic preferences and themes I didn't realize I was drawn to. It made me feel like my experience actually meant something.",
      author: "Rhea Kapoor",
      title: "Student, NYU Tisch School of the Arts"
    },
    {
      content: "I'm a bit of a museum nerd, so I tried to stump the AI with a few very niche questions about a Soviet-era poster design. To my surprise, it pulled up well-sourced, nuanced answers that even referenced a curator's commentary from an online archive. I was seriously impressed. It's far more accurate and less speculative than ChatGPT when it comes to art history.",
      author: "Kwame Mensah",
      title: "Visiting Scholar, Columbia University"
    },
    {
      content: "The homepage recommendations have made exploring my city feel like an ongoing adventure. It doesn't just suggest the big-name museums—it also surfaces smaller, lesser-known exhibits that align with my taste. Last week I discovered an experimental sound installation that I absolutely loved. Without this app, I wouldn't have even known it was happening.",
      author: "Anjali Rao",
      title: "Researcher, Art Institute of Chicago"
    },
    {
      content: "It's not just a convenience tool—it's a learning companion. After three museum visits, the app started recognizing the types of works I lingered on and recommended deeper dives into those movements. It's like Spotify Wrapped but for your cultural growth.",
      author: "Arjun Mehta",
      title: "Strategy Lead, NVIDIA Creative AI Division"
    },
    {
      content: "I'm a fan of systems thinking, and this app has a surprisingly strong backend logic. It doesn't just react to what you click—it subtly builds an understanding of your preferences and learning style. The result is a deeply personal and scalable art education journey.",
      author: "Lucas Schneider",
      title: "PhD Candidate, Stanford University"
    }
  ],
  [
    {
      content: "I don't always feel confident asking questions out loud during a museum tour. But with the AI tour guide, I could type whatever I was wondering, and the answers were thoughtful and tailored. For example, I asked about the symbolism in a surrealist painting and got a beautifully phrased, source-backed explanation in under five seconds. That kind of access is empowering.",
      author: "Natalie Greene",
      title: "Student, University of Oxford"
    },
    {
      content: "As a museum educator, I'm usually skeptical about digital tools replacing human guides. But this app doesn't replace—it complements. It gives visitors agency, lets them follow their curiosity in real time, and provides layered content in a way I wish we could always offer. I even learned something new while testing it myself.",
      author: "Tariq El-Nour",
      title: "Education Specialist, Smithsonian Institution"
    },
    {
      content: "My biggest frustration with traditional audio guides has always been the lack of depth. With this app, I chose a more academic voice setting and got nuanced content that referenced movements, dates, and even primary source quotes. It felt like a hybrid between a private docent and an interactive textbook.",
      author: "Giulia Martelli",
      title: "MA Student, Università di Bologna"
    },
    {
      content: "The app's voice response was incredibly natural—no awkward pauses or robotic intonation. I asked it how an artist's background might've influenced a specific piece, and it explained in a narrative tone, with cultural and historical references I hadn't considered. It felt like a real conversation with someone who really knows art.",
      author: "Josh Levitt",
      title: "ML Intern, MIT-IBM Watson AI Lab"
    },
    {
      content: "I visited the Met with my niece and we both used the app. She loved the interactive questions, and I appreciated being able to follow along at my own pace. By the end, she said it was more fun than her last school trip. Honestly, I learned a lot too.",
      author: "Olivia Carter",
      title: "Global Product Lead, Airbnb Experiences"
    },
    {
      content: "It changed the way I visit museums. I used to rush through rooms, now I pause, scan, listen, and reflect. I leave feeling like I've learned something meaningful rather than just checking a box.",
      author: "Eric Yang",
      title: "UX Designer, Adobe"
    },
    {
      content: "Most audio guides talk at you. This one talks with you. I asked why a piece reminded me of another painting and the AI helped me make the connection through visual motifs and shared themes. It felt personal and intelligent at the same time.",
      author: "Yuna Kwon",
      title: "Design Lead, IDEO"
    },
    {
      content: "I've used the app at major museums and small pop-up exhibits—it works beautifully in both. It doesn't rely on pre-set content alone, but builds from real-time interactions. I truly feel like I'm in dialogue with the art.",
      author: "Harris Liu",
      title: "Cultural Technologist, Cooper Hewitt Smithsonian Design Museum"
    }
  ]
]; 